import { useEffect, useState } from "react";
import { Loader2, Crown, Infinity as InfinityIcon } from "lucide-react";
import { api } from "@/lib/api";

const Bar = ({ m }) => {
  const pct = m.unlimited || !m.limit ? 0 : Math.min(100, Math.round((m.used / m.limit) * 100));
  const near = pct >= 80;
  return (
    <div data-testid={`usage-${m.key}`} className="rounded-xl border border-white/10 bg-white/[0.02] p-4">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-sm font-semibold text-white">{m.label}</span>
        <span className={`text-xs font-bold tabular-nums ${near ? "text-amber-400" : "text-[#A1A1AA]"}`}>
          {m.unlimited ? (
            <span className="flex items-center gap-1 text-[#00F0FF]"><InfinityIcon size={13} /> Unlimited</span>
          ) : (
            <>{m.used}{m.unit ? ` ${m.unit}` : ""} / {m.limit}{m.unit ? ` ${m.unit}` : ""}</>
          )}
        </span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-white/10">
        <div className={`h-full rounded-full transition-all ${m.unlimited ? "bg-gradient-to-r from-[#8B5CF6] to-[#00F0FF] opacity-40" : near ? "bg-amber-400" : "bg-[#00F0FF]"}`}
          style={{ width: m.unlimited ? "100%" : `${pct}%` }} />
      </div>
      <div className="mt-1.5 flex items-center justify-between text-[11px] text-[#666]">
        <span>{m.period === "lifetime" ? "Lifetime" : "This month"}</span>
        {!m.unlimited && <span>{m.remaining} left</span>}
      </div>
    </div>
  );
};

export default function UsageMeter({ compact }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.getUsage().then(setData).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <div className="flex justify-center py-6"><Loader2 className="animate-spin text-[#00F0FF]" size={18} /></div>;
  if (!data) return null;

  return (
    <div data-testid="usage-meter">
      {!compact && (
        <div className="mb-3 flex items-center gap-2 text-sm text-[#A1A1AA]">
          <Crown size={15} className={data.is_pro ? "text-[#FFD400]" : "text-[#A1A1AA]"} />
          <span className="font-semibold text-white">{data.plan.name}</span> plan · usage for {data.month}
        </div>
      )}
      <div className={`grid gap-3 ${compact ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
        {data.metrics.map((m) => <Bar key={m.key} m={m} />)}
      </div>
    </div>
  );
}
